import React, { useEffect, useState } from "react";
import CentreNavBar from "@/src/components/locate-us/centreNavbar";
import BannerImage from "@/src/components/locate-us/bannerImage";
import { useRouter } from "next/router";
import { centreApiService } from "@/src/lib/api-services/centreApiServices";
import CentreInfo from "@/src/components/locate-us/centreInfo";

import Head from "next/head"; // Import Head from Next.js
import DashboardLayout from "@/src/components/layout/DashboardLayout";
import MobileApps from "@/src/modules/home/mobileApps";
import { useCustomQuery } from "@/src/lib/hooks/useFetch";

const convertToMapItems = (data) => {
    if (!data) return [];
    return data.map((centre) => ({
        id: centre.urlSlug,
        name: centre.centreName,
        latitude: parseFloat(centre.centreLatitude),
        longitude: parseFloat(centre.centreLongitude),
        address: centre.centreAddress,
        phone: centre.centreMobile,
        email: "",
        hours: centre.openingHours,
        centreType: centre.centreType,
        whatsapp: centre.whatsappUrl,
        googlePlaceId: centre.googlePlaceId,
    }));
};

CentreView.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>;

export default function CentreView({ data: centreDetails }) {
    const router = useRouter();
    const { city_slug, centre_slug } = router.query;
    const currentLocation = `${city_slug}/${centre_slug}`;

    const [centers, setCenters] = useState([]);
    const [selectedCenter, setSelectedCenter] = useState(null);
    const [currentSlug, setCurrentSlug] = useState(null);
    const [centreData, setCentreData] = useState(centreDetails);

    const [city, centre] = currentSlug?.split("/") || [];

    const {
        data: mapLocations,
        isLoading: isMapLoading,
        isError: isMapError,
        error: mapError,
    } = useCustomQuery("map_locations", centreApiService.mapData);

    const mapData = convertToMapItems(mapLocations?.data);

    useEffect(() => {
        if (!!mapData) {
            setCenters(mapData);
            const currentCentre = !!centre_slug
                ? mapData.find((centre) => centre.id === currentLocation)
                : null;
            setSelectedCenter(currentCentre ? currentCentre : mapData[0]);
        }
    }, [mapData && mapData.length, centre_slug]);

    if (isMapError) {
        return <div>Error loading data.</div>;
    }

    const apiUrl = `/locate-us/${city_slug}/${centre_slug}`;
    // const centreDetails = data?.data;

    return (
        <>
            {centreDetails?.centreBannerImage && (
                <BannerImage
                    src={centreDetails?.centreBannerImage}
                    alt="Advanced imaging diagnostic service"
                />
            )}

            <div className="flex flex-col-reverse md:flex-row py-5 max-w-7xl mx-auto">
                <div className="md:w-1/4 md:pr-4 pt-3 md:pt-0">
                    <CentreNavBar currentPath={apiUrl} />
                </div>

                <div className="md:w-3/4 md:pl-4">
                    <CentreInfo
                        data={centreDetails}
                        mapData={mapData}
                        centers={centers}
                        selectedCenter={selectedCenter}
                        setCurrentSlug={setCurrentSlug}
                    />
                </div>
            </div>
            <MobileApps />
        </>
    );
}

// export default CentreView;

// This ensures that the page is server-side rendered
export async function getServerSideProps(context) {
    const { city_slug, centre_slug } = context.query;

    let data = null;
    // Fetching the specialization data (you can modify this as needed)
    try {
        const response = await centreApiService.centreDetails(
            city_slug,
            centre_slug
        );
        data = response?.data;
    } catch (error) {
        return {
            notFound: true,
        };
    }
    return {
        props: {
            data: {
                ...data,
                routerPath: `locate-us/${city_slug}/${centre_slug}`,
            },
        },
    };
}
